import React, {
  useState
} from 'react';
import PropTypes from 'prop-types';
import { toast }   from 'react-toastify';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import Request from '~/providers/Request';
import Dialog from '~/components/Dialog';
import Button from '~/components/Button';
import GridContainer from '~/components/GridContainer';
import GridItem from '~/components/GridItem';
import InputControl       from '~/components/Input/InputControl';
import InputSelectAsync   from '~/components/Input/InputSelectAsync';
import { fetchUsers } from '~/utils/fetchUsers';

function DialogAddDependent({ isOpen, onClose, owner, onSave }) {
  const [dependent, setDependent] = useState(null);
  const [isLoadingSave, setIsLoadingSave] = useState(false);

  const handleSave = () => {
    if( dependent && dependent.id ){
      setIsLoadingSave(true);
      const data = {
        dependent_id: dependent.id
      };
      Request.post(`/admin/users/${owner.id}/dependents`, data, null, { normalizeJSON: false }).then( (resp) => {
        setIsLoadingSave(false);
        setDependent(null);
        onSave(resp.data);
        toast.success('Dependente adicionado com sucesso!');
      }).catch( e => {
        console.error(e);
        toast.error('Erro ao vincular o dependente!');
        toast.error(e.message);
        setIsLoadingSave(false);
      });
    } else {
      toast.error('É necessário selecionar um usuário dependente.');
    }
  };

  return (
    <Dialog
      icon={<GroupAddIcon />}
      isOpen={isOpen}
      handleClose={onClose}
      title={'Novo vínculo de dependente'}
      dialogActions={
        <React.Fragment>
          <Button onClick={handleSave} disabled={isLoadingSave} color="primary">
            { isLoadingSave ? 'Salvando..' : 'Salvar' }
          </Button>
        </React.Fragment>
      }
    >
      <div style={{minWidth: 560}}>
        <GridContainer>
          <GridItem xs={12}>
            <InputControl
              required
              name={'dependent'}
              label={'Dependente'}
              value={dependent}
              inputComponent={InputSelectAsync}
              onChange={({dependent}) => setDependent(dependent) }
              InputProps={{
                isClearable: false,
                handleFetch: fetchUsers,
                createEnabled: false,
                error: false,
              }}
            />
          </GridItem>
        </GridContainer>
      </div>
    </Dialog>
  );
}

DialogAddDependent.propTypes={
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  owner: PropTypes.object.isRequired
};

export default React.memo(DialogAddDependent);
